<script setup lang="ts">
import {computed, ref, watch} from "vue";
import {Broadcast} from "@/types";
import {usePage} from "@inertiajs/vue3";
import {useFlash} from "@/composables/flash";

const page = usePage()
const {error, success, warning} = useFlash()

const isBannerVisible = computed(() => {
    return error.value || success.value || warning.value;
});

const bannerType = computed(() => {
    if (error.value) return 'error';
    if (success.value) return 'blue-lighten-1';
    if (warning.value) return 'amber-darken-2';
    return 'info';
});

const resetFlash = () => {
    page.props.flash = {}
}
</script>

<template>
    <v-alert
        v-if="isBannerVisible"
        variant="tonal"
        closable
        :color="bannerType"
        class="font-weight-bold mx-3 mt-3 mb-0"
        icon="mdi-alert-circle-outline"
        icon-size="20"
        @click:close.stop="resetFlash"
    >
        <span class="text-body-2 font-weight-regular text-black">
            {{ error || success || warning }}
        </span>
    </v-alert>
</template>

<style scoped>
:deep(.mdi-close) {
    color: black;
}
</style>
